module.exports = __webpack_public_path__ + "static/media/7_Chime-Switch.e13df4d9.svg";